import { makeStyles } from "@mui/styles";
import { SHADOW, borderRadius } from "../../utils/constants/UI/uiConstants";
import { BORDER, GREY } from "../../utils/constants/colors";

export const styles = {
  "@global": {
    '.MuiAutocomplete-option[data-focus="true"]': {
      background: "red ",
      border: "1px solid red",
    },
  },
  inputContainer: {
    width: "100%",
    margin: "4px 0px",
  },
  input: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    borderRadius: borderRadius.primary,
    padding: "0px 10px ",
    width: "100% ",
    height: "40px",
    border: `1px solid ${BORDER.HOVER}`,
  },
  Test: {
    width: "100% ",
    border: `1px solid ${BORDER.HOVER}`,
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
  },
  input1: {
    padding: "12px 6px ",
    height: "36px ",
    width: "100% ",
  },
  Button: {
    paddingTop: "1rem",
    width: "150px",
  },
  listBox: {
    position: "relative ",
    border: "none ",
  },
  marginTop: {
    marginTop: "1rem",
  },
  inviteBtn: {
    background: "#ff4848",
    border: "none",
    color: "white",
    width: "10vw",
    padding: "1rem 2.5rem",
    marginTop: "1rem",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  },
};
